import * as Yup from 'yup'

export const emailTemplateSchema = Yup.object().shape({
  label: Yup.string().required('Label Required!'),
  type: Yup.string().required('Type Required!'),
  // tenantId: Yup.string().required('Portal Required!')
})
